import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    companions: [],
    loaded: false
  }
};
const CompanionSlice = createSlice({
  name: "companions",
  initialState,
  reducers: {
    loadCompanions: (state, action) => {
      state.value = {
        companions: action.payload,
        loaded: true
      };
    }
  }
});
export const { loadCompanions } = CompanionSlice.actions;
export default CompanionSlice.reducer;
